import * as React from 'react'
import { MonitorOperation } from '../../domain/Operation'
import TransactionTableRowItem, { ComparisonReference, TransactionMenuType } from '../transaction-table-row-item'

export type TransactionChangeType = 'degraded' | 'improved'

interface Props {
    transactions: MonitorOperation[]
    type: TransactionChangeType
    isTideways6: boolean
    comparisonReference: ComparisonReference | null
}

export default class ChangedTransactionsList extends React.Component<Props> {
    public render() {
        const { comparisonReference, transactions, type, isTideways6 } = this.props

        if (transactions.length === 0) {
            return (
                <p>
                    There are no transactions that have {type === 'degraded' ? 'degraded' : 'improved'} significantly in the compared
                    timeframe.
                </p>
            )
        }

        return (
            <div className="box">
                <div className="box-header">
                    <h3 className="box-title">Most {type === 'degraded' ? 'Degraded' : 'Improved'} Transactions</h3>
                </div>
                <div className="box-body no-padding">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th style={{ width: 90 }} className="align-right">
                                    <span>Requests</span>
                                </th>
                                <th style={{ width: 160 }} className="align-right">
                                    <span>Slowest Response</span>
                                </th>
                                <th style={{ width: 110 }} className="align-right">
                                    <span>Impact</span>{' '}
                                </th>
                                <th style={{ width: 40 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!transactions
                                ? null
                                : transactions.map((value, index) => {
                                      return (
                                          <TransactionTableRowItem
                                              key={value.id}
                                              operation={value}
                                              compact={true}
                                              isTideways6={isTideways6}
                                              comparisonReference={comparisonReference}
                                              menuType={
                                                  isTideways6 || value.requests > 50
                                                      ? TransactionMenuType.Compare
                                                      : TransactionMenuType.None
                                              }
                                          />
                                      )
                                  })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
